import React from "react";

// Inline retry UI shown when a data load fails even after automatic retries,
// so the user can recover without losing in-progress form data.
const LoadRetryError = ({ message, onRetry }) => (
  <div className="text-center" style={{ padding: "2rem" }}>
    <p style={{ fontSize: "1.6rem", marginBottom: "1rem" }}>{message}</p>
    <button type="button" className="button" onClick={onRetry}>
      Try Again
    </button>
    <p style={{ marginTop: "1rem", fontSize: "1.3rem" }}>
      If this continues, please contact member services at (512) 505-0242.
    </p>
  </div>
);

export default LoadRetryError;
